import {MenuItem, TextField, TextFieldProps} from '@mui/material';

import {InteractionType} from '../../../interfaces/MachineInteraction';

type Props = Pick<
  TextFieldProps,
  'size' | 'name' | 'disabled' | 'fullWidth' | 'label' | 'sx'
> & {
  value?: InteractionType;
  onChange?: (value: InteractionType) => void;
};

export const InteractionTypeSelect = (props: Props) => {
  return (
    <TextField
      {...props}
      select
      onChange={(v) => {
        props.onChange?.(v.target.value as InteractionType);
      }}
    >
      <MenuItem value="all">All</MenuItem>
      <MenuItem value="employees">Employees</MenuItem>
      <MenuItem value="machines">Machines</MenuItem>
    </TextField>
  );
};
